export enum ErrorVariantEnum {
    NOT_FOUND = "not-found",
    FORBIDDEN = "forbidden",
    EMPTY = "empty",
    SERVER = "server",
    UNKNOWN = "unknown",
}

export type ErrorVariant = (typeof ErrorVariantEnum)[keyof typeof ErrorVariantEnum];

export interface ErrorPageProps {
    variant: ErrorVariant;
    title?: string;
    description?: string;
    actionText?: string;
    additionalBtn?: string;
    onAction?: () => void;
    onActionAddBtn?: () => void;
}

export const errorPageData: Record<ErrorVariantEnum, { title: string; description: string }> = {
    [ErrorVariantEnum.NOT_FOUND]: {
        title: "Нічого не знайдено",
        description: "Елемент не існує або був видалений",
    },
    [ErrorVariantEnum.FORBIDDEN]: {
        title: "Доступ заборонено",
        description: "У вас немає доступу до цього елементу або він був видалений.",
    },
    [ErrorVariantEnum.EMPTY]: {
        title: "Поки що тут порожньо",
        description: "Дані ще не додані",
    },
    [ErrorVariantEnum.SERVER]: {
        title: "Помилка сервера",
        description: "Спробуйте пізніше",
    },
    [ErrorVariantEnum.UNKNOWN]: {
        title: "Сталася помилка",
        description: "Щось пішло не так",
    },
};
